// /admin/store — the framework's store section (aldoo-ra/Admin/Store, the
// /admin/store* route), with aldoo.com's screens in it: ./store-admin
// registers Dashboards (Aldoo AI), Sales and Orders over every vendor or one,
// Shopping carts and Reservations.
import { lazyRoute } from "aldoo-ra/Router/lazy-route"
import { adminRole } from "aldoo-ra/RBAC/roles"
// the customer-support inbox learns what an order number is, and what to
// show about a customer (loaded with the routes, at boot)
import "./order-reference"
import "./customer-panels"

export default {
  // the store section opens on its sales
  "/admin/store": lazyRoute(() => import("./open-on-sales"), adminRole),
}
